$(document).ready(function() {
  // Reveal the banner image only once it is fully downloaded and decoded,
  // instead of letting it render progressively. Reveal on failure too so
  // the banner never stays hidden.
  const $banner = $('.banner-container .banner-img[data-src]');
  if ($banner.length) {
    const reveal = function() {
      $banner.addClass('is-loaded');
    };
    const img = new Image();
    img.src = $banner.data('src');
    img.decode().then(reveal, reveal);
  }

  // Unified hover function for all summary-link
  $('.summary-container .summary-link').hover(
    function() {
      const color = $(this).data('color');
      $('.summary-container').css('background-color', color);
      $('.summary-container .summary-link img').addClass('filter-to-white');
    },
    function() {
      $('.summary-container').css('background-color', '');
      $('.summary-container .summary-link img').removeClass('filter-to-white');
    }
  );
});
